import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { RecordViewWrapper, SucursalCard } from './Style';
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import {
  empleadoListAction
} from '../../../redux/administracion/empleados/actionCreator';

const EmpleadoViewPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.EmpleadoReducer.data);

  useEffect(() => {
    if (empleadoListAction) {
      dispatch(empleadoListAction());
    }
  }, [dispatch]);

  const dataSource = [];

  const handleDelete = id => {
    const confirm = window.confirm('¿Seguro de eliminar el registro seleccionado?');
    if (confirm) {
      dispatch(
        axiosDataDelete({
          id,
          getData: () => {
            dispatch(axiosCrudGetData());
          },
        }),
      );
    }
    return false;
  };

  const onHandleSearch = e => {
    if (e.target.value.length % 3 == 0) { // buscar cada que se introducen 3 letras para evitar multiples llamadas al API
      dispatch(empleadoListAction(e.target.value));
    }
  };

  if (registros.length)
    registros.map((record, key) => {
      const { id, nombre, paterno, materno, telefono_principal, nombre_sucursal, estatus, tipo_empleado } = record;
      return dataSource.push({
        key: key + 1,
        nombre: <div>{nombre} {paterno} {materno}</div>,
        telefono_principal,
        nombre_sucursal,
        estatus: <span className={`${estatus}`}>{estatus}</span>,
        tipo_empleado,
        action: (
          <div className="table-actions">
            <Tooltip title="Editar ficha de datos" color='#f8f9ac'>
              <Link className="edit" to={`/admin/recursos-humanos/editar/${id}`}>
                <FeatherIcon icon="edit" size={32} />
              </Link>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Expediente digital" color='#f8f9ac'>
              <Link className="edit" to={`/admin/recursos-humanos/expediente/${id}`}>
                <FeatherIcon icon="folder" size={32} />
              </Link>
            </Tooltip>
            &nbsp;&nbsp;
            <Tooltip title="Porcentaje de comisión" color='#f8f9ac'>
              <Link className="edit" to={`/admin/recursos-humanos/comision/${id}`}>
                <FeatherIcon icon="dollar-sign" size={32} />
              </Link>
            </Tooltip>
            {/* &nbsp;&nbsp;&nbsp;
            
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Incidencias" color='#f8f9ac'>
              <Link className="edit" to={`/admin/recursos-humanos/incidencias/${id}`}>
                <FeatherIcon icon="meh" size={24} />
              </Link>
        </Tooltip> */}
          </div>
        ),
      });
    });

  const columns = [
    {
      title: 'Sucursal',
      dataIndex: 'nombre_sucursal',
      key: 'nombre_sucursal',
    },
    {
      title: 'Rol',
      dataIndex: 'tipo_empleado',
      key: 'tipo_empleado',
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono_principal',
      key: 'telefono_principal',
    },
    {
      title: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
    },
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/recursos-humanos/agregar">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nuevo empleado</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        ghost
        title='RECURSOS HUMANOS'
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <Cards headless>
              {isLoading ? (
                <div className="spin">
                  <Spin />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 20, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default EmpleadoViewPage;
